import React from 'react'
import { Route, Routes } from 'react-router-dom'
import MobileUser from "../layout/mobileUser/MobileUser";

function MobileUserPage() {
    return (
        <>
            <Routes>
                <Route path="/" element={<MobileUser />} />
            </Routes>
        </>
    )
}

export default MobileUserPage;
